import { render, staticRenderFns } from "./stock-in-summary.vue?vue&type=template&id=c25a3a4c"
import script from "./stock-in-summary.vue?vue&type=script&lang=js"
export * from "./stock-in-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports